import HNSColors from "../../../../../ui library/HNSColors";

export const STYLES = {
  rating: {
    "& .MuiRating-icon": {
      margin: "0 4px",
    },
    "& .MuiRating-iconEmpty svg": {
      stroke: HNSColors.warning[500],
      strokeWidth: 1.5,
      fill: "transparent",
    },
    "& .MuiRating-iconFilled svg": {
      stroke: HNSColors.warning[500],
      strokeWidth: 1.5,
      fill: HNSColors.warning[500],
    },
  },
};
